/*
 * Copyright (C) Ivo Ladage-van Doorn - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Ivo Ladage-van Doorn <ivol37@gmail.com>, 2024
 */

import { participants, title } from "./utils";
import { InlineImage } from "../../components/InlineImage";

function Zomervakanties() {
  const toLeadImage = (image: string) => {
    return <InlineImage image={"lekkveld/zomervakanties/" + image + ".jpg"} />;
  };

  return (
    <div>
      <div className="box light">
        <div className="left">
          <h1>Overzicht</h1>
          <p>
            Op het kaartje onder zie je een overzicht van waar alle zomervakanties plaatsgevonden hebben. Klik op de groene huisjes om te zien wanneer we daar waren. Klik op de
            link "Zomervakanties weergeven op een grotere kaart" onderaan om de kaart in een groot window te openen.
          </p>
        </div>
        <div className="right">
          <iframe
            width="100%"
            height="300"
            src="https://maps.google.nl/maps/ms?ie=UTF8&amp;hl=nl&amp;msa=0&amp;msid=108347925099661172673.00047d8ac8d45537b26f9&amp;ll=51.224204,5.147363&amp;spn=4.352644,2.052576&amp;t=h&amp;output=embed"
          ></iframe>
        </div>
      </div>

      <div className="box main">
        <div className="left">
          {title(1994, "Vogezen (Frankrijk)")}
          {participants(4, "Paul K, Stefan, Ralph, Ivol")}
          <p>
            Hier begon het allemaal. Een fietsvakantie van Nederland (vanuit het ouderlijk huis van Stefan te Kerkrade) naar de Vogezen in Frankrijk (Saverne). De eerste dag "even"
            het hoogste punt van Belgi&euml; (Signale de Botrange) meepikken leek een goed idee, maar dat bleek toch wat zwaarder dan gedacht. We overnachtten dus noodgedwongen een
            station eerder, bij een man die het niet had op mensen-die-wel-bij-het-hotel-sliepen-maar-er-niet-aten. Toen ging alles nog met de fiets en de trein, later werd dat wel
            anders...
          </p>
          <p>
            Onlangs vond ik toevallig nog een overzicht van alle "etappes" die we tijdens die vakantie gefietst hebben inclusief de "uitslagen". Die heb ik voor de volledigheid
            opgenomen in de tabel onderaan.
          </p>
        </div>
        <div className="right">{toLeadImage("1994_fietsvakantie")}</div>
        <div className="row">
          <div className="table-container">
            <table>
              <thead>
                <tr>
                  <th>Etappe</th>
                  <th>Afstand</th>
                  <th>Gem.</th>
                  <th>Max.</th>
                  <th>Tijd (incl. rust)</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>1. Kerkrade-Robertville</td>
                  <td>70,5 km</td>
                  <td>17,3 km/uur</td>
                  <td>55,0 km/uur</td>
                  <td>7:00</td>
                </tr>
                <tr>
                  <td>2. Robertville-Troisvierges</td>
                  <td>58,0 km</td>
                  <td>17,6 km/uur</td>
                  <td>50,0 km/uur</td>
                  <td>4:10</td>
                </tr>
                <tr>
                  <td>3. Troisvierges-Vianden</td>
                  <td>57,5 km</td>
                  <td>17,0 km/uur</td>
                  <td>64,0 km/uur</td>
                  <td>7:10</td>
                </tr>
                <tr>
                  <td>4. Vianden-grevenmacher</td>
                  <td>64,2 km</td>
                  <td>18,9 km/uur</td>
                  <td>64,0 km/uur</td>
                  <td>5:40</td>
                </tr>
                <tr>
                  <td>5. Grevenmacher-Dreisbach</td>
                  <td>44,6 km</td>
                  <td>18,6 km/uur</td>
                  <td>62,5 km/uur</td>
                  <td>4:30</td>
                </tr>
                <tr>
                  <td>6. Dreisbach-Saarbrucken</td>
                  <td>64,9 km</td>
                  <td>19,0 km/uur</td>
                  <td>44,5 km/uur</td>
                  <td>4:45</td>
                </tr>
                <tr>
                  <td>7. Saarbrucken-Saverne</td>
                  <td>97,8 km</td>
                  <td>21,6 km/uur</td>
                  <td>57,5 km/uur</td>
                  <td>6:00</td>
                </tr>
                <tr>
                  <td>8. Saverne-Saarbrucken</td>
                  <td>94,8 km</td>
                  <td>23,7 km/uur</td>
                  <td>65,5 km/uur</td>
                  <td>6:20</td>
                </tr>
                <tr>
                  <td>Totaal</td>
                  <td>552,3 km</td>
                  <td>19,7 km/uur</td>
                  <td>65,5 km/uur</td>
                  <td>45:35</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div className="box light">
        <div className="left">
          {title(1995, "Grande Hoursinne (België)")}
          {participants(5, "Ivol, Stefan, Monique, Marit, Maarten")}
          <p>
            Na de geslaagde fietsvakantie kwam het jaar erna een vervolg, maar dit keer met de (van mijn ouders geleende) auto. Deze eerste 'huisjesvakantie' vond plaats in het
            vakantiehuisje van mijn ouders destijds, in Grande Hoursinne. De foto hiernaast is van het "Gourmetten". Het had echter meer weg van een in-house kampvuur... Het huisje
            is inmiddels verkocht. In eerste instantie aan vrienden, en die verkochten het later weer door. Nu woont er een Amerikaanse dame in. Van deze vakantie stammen de
            allereerste vakantieopnamen die zelfs tot film vermaakt zijn! Die film is <a href="https://ladagevandoorn.nl/films/1995.php<?php appendLogin(); ?>">hier</a> te zien,
            maar daarvoor moet je wel eerst inloggen.
          </p>

          <p>
            <b>Locatie:</b> <a href="https://www.google.nl/maps/place/50.320349,5.625475">Grande Hoursine (N 50 19.221, E 5 37.528)</a>
          </p>
        </div>
        <div className="right">{toLeadImage("1995_grande_hoursinne")}</div>
      </div>

      <div className="box main">
        <div className="left">
          {title(1996, "Grande Hoursinne (België)")}
          {participants(12, "Paul K, Onze Marion, Stefan, Maarten O, Ivol, Arnold, Lieke, Marieke, Wienand, Adi, Marcello, Mascha")}
          <p>
            Na de fietsvakantie en de 'huisjesvakantie' was de combinatie geboren: We huurden een huisje in Grande Hoursinne (pal naast het huisje van mijn ouders) en fietsten
            vanaf Kerkrade daar naar toe. De heenweg liep niet geheel vlekkeloos. De kortste fietsroute is niet altijd de "plezierigste" en al helemaal niet de snelste. Er was
            destijds slechts 1 auto mee; die van Adi.
          </p>
          <div className="subbox">
            <div className="left">
              <p>Op deze vakantie ontstond de inmiddels alom gebruikte uitdrukking "de BOB", door een door een chipszak-kijkende Paul van het merk "Bob".</p>
            </div>
            <div className="right">{toLeadImage("1996_bob")}</div>
          </div>
          <p>
            <b>Locatie:</b> <a href="https://www.google.nl/maps/place/50.320769,5.624525">Grande Hoursine (N 50 19.246, E 5 37.472)</a>
          </p>
        </div>
        <div className="right">{toLeadImage("1996_grande_hoursinne")}</div>
      </div>

      <div className="box light">
        <div className="left">
          {title(1997, "Bovigny (België)")}
          {participants(12, "Ivol, Lieke, Wienand, Ralph, Stefan, Han, Paul K, Adi, Onze Marion, Lucie, Maarten, Anouk, Joris, Martijn")}
          <p>
            Deze vakantie ging weer met de fiets. Wederom was er slechts 1 auto mee, om de boodschapen te doen. Dit maal was dat de auto van Joris, de beruchte Micra met fietsenrek
            voor 3 fietsen. Boggle was zeer hot deze vakantie. Martijn was jarig, een mooie tafeltennistafel in het zijgebouw en hier hebben we voor 1 nacht alle matrassen bij
            elkaar gelegd in 1 ruimte. Op de foto zijn we aan het BBQ-en. Dat is een traditie die tot op heden nog steeds gehanteerd wordt.
          </p>
          <p>Volgens Joris noemde Maarten O. de fietsers "watjes" toen die bij een te steile helling wat langzamer gingen.</p>
          <p>
            <b>Locatie:</b> <a href="https://www.google.nl/maps/place/50.22416,5.91429">Bovigny (N 50 13.450, E 5 54.857)</a>
          </p>
        </div>

        <div className="right">{toLeadImage("1997_bovigny")}</div>
      </div>

      <div className="box main">
        <div className="left">
          {title(1998, "Baarle Nassau (Nederland)")}
          {participants(10, "Wienand, Paul K, Han, Joris, Onze Marion, Marian, Tineke, Ivol, Kuifje, Liesbeth")}
          <p>
            Ook nu weer gingen we met de fiets en 1 auto. En jawel, tijdens deze vakantie is bewezen dat er 7 personen in een 3-deurs auto passen! Dat werd bewezen tijdens ons
            bezoek aan de Tilburgse kermis waar na afloop met name vanwege Kuifje geen teddybeer meer te vinden was.
          </p>
          <p>
            Ook de lokale Bingo werd geplunderd door Paul K en wederom Kuifje, die er met bijna alle prijzen vandoor gingen. Er werd gevoetbald met en tegen de lokale
            vakantiegangers. Maar je moest voorzichtig zijn; bij het minste of geringste ging de tweeling huilen en moest het spel stilgelegd worden.
          </p>
          <p>Dit alles vond plaats in een bugalow op een vakantiepark, "De Steppe" genaamd.</p>
          <p>
            <b>Locatie:</b> <a href="https://www.google.nl/maps/place/51.450161,4.889478">De Steppe (N 51 27.010, E 4 53.369)</a>
          </p>
        </div>

        <div className="right">{toLeadImage("1998_baarle_nassau")}</div>
      </div>

      <div className="box light">
        <div className="left">
          {title(1999, "Terschelling (Nederland)")}
          {participants(10, "Ivol, Tineke, Stefan, Joyce, Joris, Marian, Paul K, Onze Marion, Wienand, Han")}
          <p>
            Naar Terschelling werd het anders. Geen fiets meer, slechts auto's. Het was nog wel even doorkarren, omdat Ivo op de A50 de verkeerde afslag had genomen. De auto's
            bleven achter in Harlingen, en ter plekke werden fietsen gehuurd. De auto van de oma van Paul (de schitterende Ford Taunus) werd ingezet voor het halen van de
            boodschappen.
          </p>
          <p>
            In het strandzand werd Stefan ingegraven en voorzien van duidelijke 'uiterlijke kenmerken'. Voor hen die die foto nog kennen is het duidelijk wat daarmee bedoeld
            wordt...
          </p>

          <p>
            <b>Locatie:</b> <a href="https://www.google.nl/maps/place/53.372018,5.239064">Landzicht (N 53 22.321, E 5 14.344)</a>
          </p>
        </div>

        <div className="right">{toLeadImage("1999_terschelling")}</div>
      </div>

      <div className="box main">
        <div className="left">
          {title(2000, "Halleux (België)")}
          {participants(10, "Ralph, Kuifje, Stefan, Han, Tineke, Ivol, Joyce, Wienand, Linda, Paul K, Marian, OnzeMarion, Roel")}
          <p>
            Van deze vakantie stamt de fameuze uitdrukking "Halleu!!!" die nog regelmatig gebruikt wordt. Deze foto is van het beruchte maisdoolhof waarbij Kuifje nog een Mummie op
            zijn rug meegenomen heeft. Toen waren er nog geen kinderen bij, en daarom kwam het kind in menig vakantieganger naar boven. Ook de Quasimodo-imitatie van Stefan
            (tijdens een regenbui bij het bezoek aan de burcht van La-Roche) stamt uit deze vakantie.
          </p>
          <p>
            Bij deze vakantie werd er fanatiek ge-"adventured", inclusief tokkelbaan. Het toppunt was echter wel het "ondergrondse doolhof". Dit klonk erg gaaf maar in weze waren
            het een paar gangen waardoor je in het pikkedonker en op de buik je weg moest zien te vinden naar de uitgang. Als je de uitgang eindelijk gevonden had en het stof uit
            je ogen geklopt had zag je pas wat je je kleren had aangedaan...
          </p>
          <p>
            <b>Locatie:</b> <a href="https://www.google.nl/maps/place/50.172616,5.504934">Mignonsart (N 50 10.357, E 5 30.296)</a>
          </p>
        </div>

        <div className="right">{toLeadImage("2000_halleux")}</div>
      </div>

      <div className="box light">
        <div className="left">
          {title(2001, "Sosoye (België) en Tours-Sur-Marne (Frankrijk)")}
          {participants(13, "Roel, Linda, Stefan, Joyce, Ivo L, Nivo, Tineke, Paul K, Onze Marion, Kuifje, Wienand, Monique, Joris")}
          <p>
            Hier was het dat velen leerden Jongleren. Ook de "Geend", op de foto hiernaast, was een topattractie. En dat in een stuk tuin waarvan nooit duidelijk is geworden of het
            wel bij ons huisje hoorde... Andere bekende gebeurtenissen; Ivo L die opgesloten zat in de WC en de uitspraak van Joris "We zijn zeker voor zonsondergang terug!" (wat
            dus diep in de nacht werd...) Meest gehoorde uitspraak; "Ullrich muss mit!!!"
          </p>
          <p>
            Een fotospeurtocht werd uitgezet in het lokale dorp, tot groot ongenoegen van de lokale bevolking. Die zag ons al snel voor spionnen aan en de route moest dan ook
            aangepast worden.
          </p>

          <p>
            <b>Locaties:</b> <a href="https://www.google.nl/maps/place/50.296594,4.782838">La Molignette, Sosoye (N 50 17.796, E 4 46.970)</a>
            <br />
            <a href="https://www.google.nl/maps/place/49.046665,4.123376">Rue de l'Eglise 10, Tours-Sur-Marne, Sosoye (N 49 2.800, E 4 7.403)</a>
          </p>
        </div>

        <div className="right">{toLeadImage("2001_sosoye_en_tours_sur_marne")}</div>
      </div>

      <div className="box main">
        <div className="left">
          {title(2002, "Dasburg (Duitsland)")}
          {participants(11, "Maarten, Tineke, Nivo, Wienand, Paul K, Onze Marion, Hans, Ivol, Loek, Roel, Linda")}
          <p>
            Dit keer eens niet naar België, maar naar Duitsland (tegen de Luxemburgse grens weliswaar). Dit was de vakantie van met name de theatersport. Nivo had zijn
            theatersportboekje meegenomen en hier werd volop gebruik van gemaakt. Verder was daar natuurlijk het bezoek aan de Tour de France, waar Lance Armstrong nog voorbij kwam
            zoefen. En dat werd dan gefilmd door tenminste 7 helikopters. Nivo was jarig tijdens deze vakantie zoals op de foto te zien is.
          </p>

          <p>
            <b>Locatie:</b> Dasburg (preciese locatie onbekend)
          </p>
        </div>

        <div className="right">{toLeadImage("2002_dasburg")}</div>
      </div>

      <div className="box light">
        <div className="left">
          {title(2003, "Nommern (Luxemburg)")}
          {participants(7, "Loek, Paul K, Onze Marion, Joris, Jantineke, Ivol, Reino")}
          <p>
            Deze vakantie vond voor het eerst plaats in Luxemburg, al heel vroeg in het jaar. Prachtig weer was het, maar het tourisme was duidelijk nog niet op gang. Alles, maar
            dan ook echt alles, was dicht. Paardrijden kon alleen als je de daarvoor benodigde spullen had, de zwembaden die al gevonden konden worden waren nog niet gevuld met
            water en de enige kano's die langs het levensgrote meer te vinden waren, werden alleen verhuurd aan de lokale bevolking (en voor dat antwoord moesten we wachten tot de
            beste man klaar was met zijn lunch). Eén van de weinige dingen die wel open waren, waren de mijnen van Roumelange op de foto hiernaast.
          </p>
          <p>
            <b>Locatie:</b> <a href="https://www.google.nl/maps/place/49.794203,6.177268">Rue du Knapp 93 (N 49 47.652, E 6 10.636)</a>
          </p>
        </div>

        <div className="right">{toLeadImage("2003_nommern")}</div>
      </div>

      <div className="box main">
        <div className="left">
          {title(2005, "Morville (België)")}
          {participants(13, "Tineke, Monique, Ivol, Elise, Paul K, Onze Marion, Lieke, Roel, Linda, Luuk, Sophie, Loek, Joris")}
          <p>
            Dit was het huisje met de vele kamertjes, de grote badkamer, de tafelvoetbaltafel en het speeltoestel in de tuin. Dagelijks werd er gekonkelt over het spel Diplomacy
            maar ook Weerwolven maakte hier zijn entree. Van deze vakantie zijn videobeelden, maar die zijn nog nooit vertoond...
          </p>
          <p>
            Het huisje heette "Le Gite Hourlay", zie <a href="http://www.legitehourlay-durbuy.be/">http://www.legitehourlay-durbuy.be/</a>.
          </p>

          <p>
            <b>Locatie:</b> <a href="https://www.google.nl/maps/place/50.338608,5.537494">Le Gite Hourlay (N 50 20.316, E 5 32.250)</a>
          </p>
        </div>

        <div className="right">{toLeadImage("2005_morville")}</div>
      </div>

      <div className="box light">
        <div className="left">
          {title(2006, "Ovifat (België)")}
          {participants(15, "Paul K, Onze Marion, Lieke, Inge, Roel, Linda, Luuk, Sophie, Ivol, Elise, Tineke, Joris, Loek, Monique, Wienand")}
          <p>
            Deze vakantie vond plaats in het zeer luxe huisje in Ovifat, met sauna in de kelder, badmintonveld, voetbalveld, Jeux de Boulesbaan en tafelvoetbaltafel. Later kwam
            deze villa nog op TV bij een of andere serie over luxe oorden. En Lux was het zeker, zo had iedere kamer zijn eigen badkamer!
          </p>
          <p>
            Er werd hier nog gevliegerd, maar dat werd geen success. De vlieger belandde op het dak en daar Ivo hoogtevrees heeft klom Joris het dak op om de vlieger te bevrijden,
            hetgeen nog allesbehalve makkelijk ging.
          </p>

          <p>
            <b>Locatie:</b> <a href="https://www.google.nl/maps/place/50.464837,6.096041">Thermae (N 50 27.890, E 6 5.762)</a>
          </p>
        </div>

        <div className="right">{toLeadImage("2006_ovifat")}</div>
      </div>

      <div className="box main">
        <div className="left">
          {title(2007, "Noville (België)")}
          {participants(12, "Stefan, Joyce, Ivol, Elise, Joris, Marigje, Loek, Gea, Henk Alle, Paul E, Soek Hwa, Maarten O")}
          <p>
            Dit maal een vakantie van een hele andere opzet. Een soort van "Wie is de Mol", maar dan in het eggie. Winnaars: Stefan en Henk Alle. Het huisje was een oude molen met
            een stromende rivier ernaast, wat prima bij het middeleeuwse thema paste. Dit vakantiehuisje heette "le Moulin d'en Bas".
          </p>
          <p>Op de foto links is te zien dat we in feite met een stel kinderen op vakantie waren. Het blijft toch leuk een ander ezelsoren te geven op de foto...</p>

          <p>
            <b>Locatie:</b> <a href="https://www.google.nl/maps/place/50.073605,5.751385">Le Moulin d'en bas (N 50 4.416, E 5 45.083)</a>
          </p>
        </div>

        <div className="right">{toLeadImage("2007_noville")}</div>
      </div>

      <div className="box light">
        <div className="left">
          {title(2008, "Goesnes (België)")}
          {participants(17, "Paul K, Onze Marion, Inge, Lieke, Roel, Linda, Luuk, Sophie, Paul E, Loek, Monique, Tineke, Wienand, Ivol, Elise, Joris, Marigje")}
          <p>
            Weer een reguliere zomervakantie in de Belgische Ardennen. PacMan was hier toch wel het spel van de week. Roel leerde hier &eacute;&eacute;nwielen. Er werd natuurlijk
            weer een hoop geweerwolfd en Tineke had diverse Geocache-routes meegenomen. En om luid en duidelijk over te komen had Ivol zijn megafoon meegenomen, wat in ieder geval
            bij de kinderen een groot succes was...
          </p>
          <p>
            Dit was het huisje van de vele strontvliegen. Roel en Paul K dachten een bijdrage te leveren door zo'n 100 vliegen per uur plat te slaan... Hier stond Joris al te koken
            voordat de eigenaresse met de rondleiding door de keuken kwam. De groep wordt steeds groter, tijdens deze vakantie al 17, en dat aantal zou de komende jaren nog een
            stuk hoger worden.
          </p>
          <p>
            <b>Locatie:</b> <a href="https://www.google.nl/maps/place/50.461762,5.202232">Le chateau-ferme de Baya (N 50 27.706, E 5 12.134)</a>
          </p>
        </div>

        <div className="right">{toLeadImage("2008_goesnes")}</div>
      </div>

      <div className="box main">
        <div className="left">
          {title(2009, "Thimister-Clermont (België)")}
          {participants(19, "Paul K, Onze Marion, Inge, Lieke, Roel, Linda, Luuk, Sophie, Paul E, Loek, Monique, Tineke, Ivol, Elise, Joris, Marigje, Rianne, Lenny, Onze Henk")}
          <p>
            Na wat getouwtrek Nederland versus België werd het uiteindelijk toch weer België. Het blijft een feit dat je daar veel meer huis voor hetzelfde geld krijgt. En een
            prachtig huis was het; met grote tuin, 6 grote tafels buiten, speeltoestel, sfeervolle kelder, sauna en een relax ruimte met ondermeer een tafeltennistafel en een ruime
            keuken. Vele watergevechten werden er gehouden (zoals op de foto) en diverse speurtochten werden uitgezet.
          </p>
          <p>
            De heenreis deden de meesten per auto maar Paul K, Onze Henk, Ivo en Rianne deden dat per fiets. Dit ging niet helemaal op rolletjes; de ketting van Ivo's fiets viel er
            om de haverklap af en bij ietwat steile hellingen trapte hij door waardoor deze lopend bestegen moesten worden. Elise en Tineke moesten dan ook uitrukken om de
            gesneuvelde fiets om te ruilen voor de racefiets van Tineke.
          </p>
          <p>
            Tijdens de vakantie werd er gezwommen, geklommen, ge-geocached, hardgelopen, de beide Paulen verzorgde een speciaal GURPS avontuur voor beginners en er werd bij ieder
            ontbijt en avondeten buiten gegeten. Het weer was de hele week dan ook prachtig met zelfs 2 dagen met temperaturen van ruim boven de 30 graden. Op de heetste dag werd
            dan ook de kelder opgezocht.
          </p>
          <p>
            Halverwege werd <i>The Fellowship Of The Cheese</i> uitgeroepen; een genootschap wat eerst nog in het openbaar 's avonds kaas at (in den beginne bestaande uit Lenny,
            Rianne, Ivo en Paul K). De geur werd de meesten teveel en de bijeenkomsten werden ook al snel verboden binnenshuis (en Paul K haakte af). Bij regen verzamelde het
            genootschap op een geheime dubbele kamer in de kelder om de beruchte stinkkaas alsnog te verorberen...
          </p>
          <p>
            De terugweg verliep voor de twee overgebleven fietsers (Ivo en Rianne) in eerste instantie voorspoedig maar ook dit eindigde in een drama. In Sippenaken kreeg Ivo een
            lekke band. Kan gebeuren, alleen bleek de Belgische reparateur niet alleen de ketting, tandwielen voor en achter, derailleur en buitenband achter vervangen te hebben,
            maar ook de binnenband achter. En met een Frans ventiel uiteraard. Na een hoop gepruts lukte het deze weer op te pompen en kon de tocht vervolgt worden. Slechts 5 km
            voor Nijmegen ging het opnieuw mis; weer een lekke band. Na pogingen om de band op te pompen brak het ventiel af en kon de gloednieuwe binnenband officieel overleden
            verklaard worden. Ook nu weer werd Elise opgeroepen om de twee fietsers op te halen. Dat ging echter niet; het fietsenrek bleek onmogelijk twee fietsen te kunnen
            vervoeren ondanks verwoede pogingen. En dus moest Rianne alleen de laatste kilometers afleggen...
          </p>
          <p>
            <b>Locatie:</b> <a href="https://www.google.nl/maps/place/50.648005,5.844657">Stokis (N 50 38.880, E 5 50.679)</a>
          </p>
        </div>

        <div className="right">{toLeadImage("2009_stokis")}</div>
      </div>

      <div className="box light">
        <div className="left">
          {title(2010, "Vielsalm (België)")}
          {participants(
            24,
            "Paul K, Onze Marion, Inge, Lieke, Roel, Linda, Luuk, Sophie, Paul E, Loek, Miek, Tineke, Irving, Ivol, Elise, Joris, Marigje, Rianne, Lenny, Onze Henk, Dennis, Stefan, Joyce, Lily"
          )}
          <p>
            Met een grotere groep dan ooit daarvoor huurden wij een oud hotel, vlakbij de Baraque de Fraiture. Wat voor een hotel het vroeger precies geweest is blijft gissen, maar
            dat het "shabby" was, daar was iedereen het wel over eens. De rode lampen op de nachtkastjes spraken bij velen tot de verbeelding.
          </p>
          <p>
            Tijdens deze vakantie werd er natuurlijk weer geklommen, gegeocached, gewandeld en werden er natuurlijk weer veel spelletjes gespeeld. Nieuw dit jaar was wat in de
            wandelgangen "De Computerclub" genoemd werd. Doorgaans bestaande uit Stefan, Loek en Paul E werd menig potje DotA gespeeld. Andere jaren was er nog sprake van een
            laptop verbod, maar met de aanwezigheid van tenminste 5 laptops dit jaar werd het verbod massaal genegeerd.
          </p>
          <p>
            Alhoewel het weer deze week zeker niet slecht was, haalde het het niet bij het prachtige weer wat we gewend waren van het jaar daarvoor. Slechts 1 dag moest er binnen
            gebleven worden vanwege regenval en de traditionele BBQ kon gewoon doorgang vinden. Van een watergevecht kwam het echter niet, alhoewel Roel daartoe nog pogingen
            ondernam.
          </p>
          <p>
            De meeste vakantiegangers legden de heen en terugreis af met de auto. Een selecte groep, bestaande uit Lenny, Atari Paul, Onze Henk, Dennis, Rianne en Ivo besloten
            echter de reis per fiets af te leggen. Omdat de afstand en hoogteverschillen wel erg groot waren werd de afstand in 2 dagen overbrugt, met een overnachting in Verviers.
            Dat bleek geen overbodige luxe, gezien de hoeveelheid beklimmingen en afdalingen die voor deze barre tocht noodzakelijk waren (getuige de foto).
          </p>
          <p>
            Traditioneel viel er weer genoeg te beleven tijdens de fietstocht. De fiets van Dennis deed daartoe een aardige duit in het zakje. Zo viel op de heenweg de trapper er
            af en bleek op de terugweg, op het moment dat er flink gedaald moest gaan worden, dat de remkabel (van de achterrem) zo goed als doorgebroken was. Onderweg werd er nog
            een vrouw uit de bosjes gered die om hulp riep en de volop bewoonde (spinnen, (naakt)slakken, etc.) badkamer in de B&B te Verviers schiep op de terugweg veel
            hilariteit.
          </p>
          <p>
            Maar de klap op de vuurpijl kwam op het moment dat niemand het meer verwachtte; het moment dat iedereen dacht niet meer te hoeven fietsen. De NS bleek het weekend van
            de terugweg werkzaamheden te verrichten aan het spoor waardoor er geen treinen reden op het traject Sittard-Roermond. En dus zat er niets anders op; dit stuk moest
            alsnog met de fiets afgelegd worden...
          </p>
          <p>
            <b>Locatie:</b> <a href="https://www.google.nl/maps/place/50.243909,5.746922">Le Relais de la Fagne (N 50 14.635, E 5 44.815)</a>
          </p>
        </div>

        <div className="right">
          {toLeadImage("2010_vielsalm")} {toLeadImage("2010_vielsalm_2")}
        </div>
      </div>

      <div className="box main">
        <div className="left">
          {title(2011, "Vlessart (België)")}
          {participants(
            27,
            "Paul K, Onze Marion, Inge, Lieke, Roel, Linda, Luuk, Sophie, Paul E, Loek, Kerstin, Miek, Tineke, Irving, Ivol, Elise, Mathijs, Joris, Marigje, Rianne, Lenny, Onze Henk, Dennis, Stefan, Joyce, Lily, Kim"
          )}
          <p>
            Net als het jaar ervoor was de groep ook dit jaar weer groter dan ooit daarvoor. Eigenlijk was de groep net zo groot als vorig jaar, maar vanwege gezinsuitbreiding net
            ietsje groter. Loek en Kerstin waren maar 1 dag bij ons.
          </p>
          <p>
            De heenreis werd door de Doortrappers op traditionele afgelegd; op de fiets. Alleen Rianne, ook wel bekend als fietsertje 3, ging niet mee vanwege het feit dat ze
            daarvoor al een andere vakantie had en zodoende vanuit Frankrijk vertrok. De terugweg moest ook Ivo afhaken, vanwege een zieke vrouw en een ziek kind. Naar verluidt
            hebben de overige doortrappers op de terugweg het spookdorp Romeldange aangedaan.
          </p>
          <p>
            Het weer was onlangs de slechte voorspellingen nog redelijk. Over het algemeen was het droog met een waterig zonnetje. De temperatuur kon beter, maar soms kon er toch
            aardig buiten gezeten worden. De traiditonele BBQ kon dan ook dit jaar weer doorgang vinden.
          </p>
          <p>
            Geklommen werd er niet, in de buurt was er geen beklimbare rots aanwezig. Wel werd er gewandeld. In Saint Hubert om precies te zijn. 20 km van Vlessart volgens Onze
            Henk, maar in de praktijk bleek dit 50 km te zijn. Ook de wandelroute zelf bleek twee maal zo lang als verwacht. Een dag later vroeg iedereen zich af waarom we 50 km
            gereden hebben om in Saint Hubert te wandelen terwijl ons huisje grenst aan een groot bos wat vele malen mooier is dan het bos in Saint Hubert. Dat mysterie is echter
            nog altijd onopgelost.
          </p>
          <p>Irving organiseerde een "Battletour". Hij voer ons via Bouillon naar Sedan waar in de 1e en 2e wereld oorlog menig strijd is geleverd.</p>
          <p>Spelletjes werden er natuurlijk weer volop gedaan. Naast Saboteur en de Grote Dalmuti waren dit jaar Agricola en Loyan ook erg in trek.</p>

          <p>
            <b>Locatie:</b> <a href="https://www.google.nl/maps/place/49.795999,5.648308">Vlessart (Léglise) (N 49 47.760, E 5 38.898)</a>
          </p>
        </div>

        <div className="right">
          {toLeadImage("2011_vlessart")} {toLeadImage("2011_vlessart_2")}
        </div>
      </div>

      <div className="box light">
        <div className="left">
          {title(2012, "Xhoffraix (België)")}
          {participants(
            20,
            "Paul K, Onze Marion, Inge, Lieke, Paul E, Miek, Tineke, Irving, Ivol, Elise, Mathijs, Joris, Marigje, Rutger, Rianne, Bokkie, Lenny, Aldert, Onze Henk, Dennis"
          )}
          <p>
            Al jarenlang werd de groep alsmaar groter en groter, maar dit keer waren we toch echt met 7 minder dan het jaar ervoor. Wederom was er een voormalig hotel gevonden, en
            ditmaal was er behalve een pooltafel en tafeltennistafel zelfs een zwembad met jacuzzi.
          </p>
          <p>
            De heenreis werd door de Doortrappers op traditionele afgelegd; op de fiets. Met een nieuw lid in de gelederen, Aldert, werd de 142 km vanaf Roermond afgelegd. Een
            klein dieptepunt was er vlak voor het einde, toen Paul's band het begaf op stijl aflopend keienpad en deze geplakt moest worden onder het genot van een ware wolkbreuk.
          </p>
          <p>
            Het "huisje" was aan een opknapbeurt toe, desalniettemin was het van alle gemakken voorzien. Behalve het vervangen van de wasmachine en het feit dat Elise werd
            gelectrocuteerd door haar nachtlampje, hoefden er geen spoedreparaties gedaan te worden. Van het zwembad werd gretig gebruik gemaakt.
          </p>
          <p>
            het spel van de week was Axis en Allies, waarbij de Hitler imitatie van Paul E op grote schaal geimiteerd werd. Maar omdat deze week in België plaatsvond kon het geen
            kwaad.
          </p>

          <p>
            <b>Locatie:</b> <a href="https://www.google.nl/maps/place/50.457854,6.068986">Le Tchession (N 50 27.471, E 6 4.139)</a>
          </p>
        </div>

        <div className="right">
          {toLeadImage("2012_xhoffraix")} {toLeadImage("2012_xhoffraix_2")}
        </div>
      </div>

      <div className="box main">
        <div className="left">
          {title(2013, "Brilon (Duitsland)")}
          {participants(
            24,
            "Paul K, Onze Marion, Inge, Lieke, Roel, Linda, Luuk, Sophie, Paul E, Miek, Tineke, Irving, Ivol, Elise, Mathijs, Joris, Marigje, Rutger, Rianne, Bokkie, Lenny, Aldert, Onze Henk, Dennis"
          )}
          <p>
            Veel moeite moest er gedaan worden, maar het was eindelijk gelukt: een huisje wat aan alle eisen voldeed en NIET in België lag. Zowaar werd er een huisje gevonden in
            Sauerland, Duitsland. De groep was hard toe aan een nieuwe omgeving, en eindelijk was in die omgeving een huisje gevonden.
          </p>
          <p>
            De omgeving van Sauerland had voor elk wat wils. Een buitenzwembad, dierenpark, rodelbaan, de Warsteiner bierbrouwerij en niet te vergeten de prachtige glasblazerij.
          </p>
          <p>
            Het huisje was, zoals inmiddels gewoon, een voormalig hotel. Gelegen op een mooie plek in de buitenwijk van Brilon. Het huisje had genoeg kamers en was voorzien van een
            tafeltennistafel, dartbord en terras.
          </p>
          <p>
            Het was die week wat wisselvallig weer, varierend van matig met regen, tot bloed, en dan ook werkelijk, bloedheet. De doortrappers vertrokken 's ochtends om 10:00, toen
            het buiten net de 30 graden aantikte. En dat was dan nog 's ochtends vroeg...
          </p>
          <p>
            <b>Locatie:</b> <a href="https://www.google.nl/maps/place/51.371833,8.581566">Sauerländer Tor (N 51 22.310, E 8 34.894)</a>
          </p>
        </div>

        <div className="right">
          {toLeadImage("2013_brilon")} {toLeadImage("2013_brilon_2")}
        </div>
      </div>

      <div className="box light">
        <div className="left">
          {title(2014, "Niedersorpe (Duitsland)")}
          {participants(
            24,
            "Paul K, Onze Marion, Inge, Lieke, Roel, Linda, Luuk, Sophie, Paul E, Ivol, Elise, Mathijs, Evie, Joris, Marigje, Rutger, Vera, Rianne, Bokkie, Lenny, Aldert, Jasper, Onze Henk, Dennis"
          )}
          <p>
            Wederom koste het vinden van een huisje veel moeite. Met passen, meten en diverse "offers" werd er uiteindelijk toch weer een huisje gevonden in Sauerland. In de
            omgeving was er weer voor ieder wat wils. Een zwembad, modeltreinbaan, pretparken, rodelbaan, het Erlebnispfad, de trimbaan, en de Bruchhauser steinen.
          </p>
          <p>
            Het huisje was voorzien van diverse speelattributen. Zo was er een bioscoopzaal in het huisje zelf, een speelzolder met tafeltennis en tafelvoetbal en een grote tuin
            met trampoline. Vooral van de trampoline werd veel gebruik gemaakt.
          </p>
          <p>
            Het was die week redelijk goed weer. De doortrappers hadden het zwaar dit jaar, vooral op de heenweg. De heenweg was langer dan ooit daarvoor, en beide dagen werden
            aankomsten in het donker (waarvan de eerste zelfs zonder avondeten).
          </p>
          <p>
            <b>Locatie:</b> <a href="https://www.google.nl/maps/place/51.169222,8.358550">Sorpehaus (N 51 10.153, E 8 21.513)</a>
          </p>
        </div>

        <div className="right">
          {toLeadImage("2014_niedersorpe")} {toLeadImage("2014_niedersorpe_2")}
        </div>
      </div>

      <div className="box main">
        <div className="left">
          {title(2015, "Ovifat (België)")}
          {participants(
            24,
            "Paul K, Onze Marion, Inge, Lieke, Roel, Linda, Luuk, Sophie, Paul E, Ivol, Elise, Mathijs, Evie, Joris, Marigje, Rutger, Vera, Rianne, Bokkie, Onze Henk, Dennis, Tineke, Irving, Abel"
          )}
          <p>
            En we waren weer terug op onze thuisbasis; de Belgische ardennen. De fietsers fietsten vanaf Eindhoven dit maal, via zuid Limburg en de lang vergeten treinroute de
            "Vennbahn". Het huisje was voorzien van een mooie grote tuin met trampoline en picnic tafels. Binnen was er een professionele keuken. Buitenzitten kon wel, maar de
            wespen overheersten. Toen er voor de BBQ een knoflooksaus geproduceerd werd die in eerste instantie niet voor menselijke consumptie geschikt was, werd deze saus ingezet
            ter bestrijding van het wespennest, de bron van alle ellende. Paul, Bokkie en Ivo gingen op kruistocht ter uitroeing van het wespennest, maar Bokkie moest de strijd
            vroegtijdig staken.{" "}
          </p>
          <p>Er werd gerodeld op de dichtstbijzijnde rodelbaan, voor de kinderen was er een speurtocht uitgezet en ouders met jonge kinderen gingen naar Plopsaland.</p>

          <p>
            <b>Locatie:</b> <a href="https://www.google.nl/maps/place/50.469715,6.105937">La Fagna (N 50 28.183, E 6 6.356)</a>
          </p>
        </div>

        <div className="right">
          {toLeadImage("2015_ovifat")} {toLeadImage("2015_ovifat_2")}
        </div>
      </div>

      <div className="box light">
        <div className="left">
          {title(2016, "Noordeloos (Nederland)")}
          {participants(
            24,
            "Paul K, Onze Marion, Inge, Lieke, Linda, Luuk, Sophie, Ivol, Elise, Mathijs, Evie, Joris, Marigje, Rutger, Vera, Onze Henk, Dennis, Tineke, Irving, Abel, Lasse (nog in de buik), Aldert, Lenny, Jasper, Karlijn"
          )}
          <p>
            Voor het eerst sinds lange tijd gingen we weer eens in Nederland op vakantie. Omdat de fietsroute daarmee niet erg lang was, haakte Ivo af maar gaf het Inge de
            mogelijkheid eens mee te fietsen.
          </p>
          <p>
            Het werd de vakantie waar alles draaide om <b>de Bedwants</b>. Diverse vakantiegangers kregen last van uitslag; vele bultjes dicht op elkaar. Het vreemdste geval was
            het been van onze Henk, die altijd een lange broek draagt, zelfs 's nachts. Het vermoeden rees dan ook dat het een of ander beestje was wat in de matrassen zat. Er
            werden wat beestjes gevangen en meegegeven aan een 'expert'. Deze oordeelde dat het geheel gedesinfecteerd moest worden. Dat hield in: alles uit de kamers, spuiten, en
            alleen volwassenen en oudere kinderen mochten er daarna nog slapen. Evie sliep daardoor noodgedwongen op de gang.
          </p>
          <p>
            Al snel bleek er echter helemaal niets aan de hand te zijn. Of in ieder geval; de ongediertenbestrijder had geen bedwants of ander ongedierte aangetroffen. Achteraf
            volgde er een 'opstootje' met de verhuurder, die in eerste instantie de borg niet terug wilde geven omdat dit geintje hem natuurlijk veel geld had gekost. Uiteindelijk
            was ook hij het erover eens dat tot de hele actie besloten werd door de man van de ongediertebestrijding die als eerste kwam kijken.
          </p>
          <p>
            Verder werd er gegolfd op de ernaast liggende golfbaan, werd Kinderdijk bezocht en Slot Loevestein. Daarnaast werd er veel tijd besteed aan de "Mobiele escape room" die
            Ivo in elkaar had gezet. Dit tot groot verdriet van Onze Henk, die constateerde dat er daardoor maar weinig gegadigden overbleven voor een ouderwets spelletje.
          </p>
          <p>
            <b>Locatie:</b> <a href="https://www.google.nl/maps/place/51.897802,4.927860">Maria Johanna Hoeve (N 51 53.868, E 4 55.672)</a>
          </p>
        </div>

        <div className="right">
          {toLeadImage("2016_noordeloos")} {toLeadImage("2016_noordeloos_2")}
        </div>
      </div>

      <div className="box main">
        <div className="left">
          {title(2017, "Gembloux (België)")}
          {participants(
            28,
            "Paul K, Onze Marion, Inge, Lieke, Linda, Luuk, Sophie, Ivol, Elise, Mathijs, Evie, Joris, Marigje, Rutger, Vera, Onze Henk, Dennis, Tineke, Irving, Abel, Lasse, Aldert, Lenny, Jasper, Karlijn, Rianne, Bokkie, Sietze, Paul E"
          )}
          <p>
            En we waren weer terug in het oude vertrouwde Belgi&euml;. Wel in een iets ander gedeelte, namelijk brij Brussel in de buurt. En dus werd Brussel regelmatig bezocht.
            Voor het Atomium, voor Mini europe, voor De Dino expo, het Planetarium en voor het Chocolademuseum.
          </p>
          <p>
            Het was de vakantie van de Whatsapp. Er werd driftig geappt op de daarvoor speciaal aangemaakte vakantie-app. Zelfs als het eten klaar was, ging er een appje rond dat
            men kon eten. Het was ook lastig om iedereen bij elkaar te krijgen omdat alleen de slaapplaatsen al verdeeld waren over 3 gebouwen. Het was ook de vakantie ewaar ieder
            zijn eigen ding deed, nog niet eerder werd er zo weinig met "de hele groep" gedaan.
          </p>
          <p>
            De BBQ viel letterlijk in het water, voor het eerst sinds de introductie van deze traditie. Noodgedwongen moest het vlees bereid worden met een paraplu boven de BBQ.
            Maar dat mocht de pret niet drukken. Al helemaal niet toen het wel bekende 'oh boy' incident plaatsvond.
          </p>
          <p>
            Toen het even droog was en een groepje buiten na zat te genieten van de BBQ pakte donkere wolken zich samen en begon het zachtjes te regenen. Een of andere onverlaat
            zei daarop de historische woorden; <i>de eerste die nu opstaat en naar binnen gaat is een watje</i>. Rianne koos al snel eieren voor haar geld en ging naar binnen. Net
            terwijl de rest opgelucht adem wilde halen was het een andere malloot die zei <i>en wie nu nog opstaat en naar binnen gaat is al helemaal een watje!</i> Daarop restte
            de aanwezigen nog maar 1 keus; blijven zitten totdat deze wolkbreuk voorbij was. En een wolkbreuk werd het. Maar alle aanwezigen (Paul K, Dennis, Paul E, Luuk, Bokkie
            en Ivo) bleven dapper zitten, uitgejouwd door de mensen die vonden dat ze naar binnen moesten komen. Uiteindelijk hield het op met regenen en kon iedereen eindelijk
            naar binnen.
          </p>

          <p>
            <b>Locatie:</b> <a href="https://www.google.nl/maps/place/50.531248,4.715986">Ferme de Ferooz (N 50 31.875, E 0 24.959)</a>
          </p>
        </div>

        <div className="right">
          {toLeadImage("2017_gembloux")} {toLeadImage("2017_gembloux_2")} {toLeadImage("2017_gembloux_3")}
        </div>
      </div>

      <div className="box main">
        <div className="left">
          {title(2018, "Saint Gervais (Frankrijk)")}
          {participants(
            26,
            "Paul K, Onze Marion, Inge, Lieke, Linda, Luuk, Sophie, Ivol, Elise, Mathijs, Evie, Onze Henk, Dennis, Tineke, Irving, Abel, Lasse, Aldert, Lenny, Jasper, Karlijn, Rianne, Bokkie, Sietze, Paul E, Roel"
          )}
          <p>
            Dit jaar gingen we eens naar Frankrijk, het was lang geleden dat we daar voor het laatst met deze groep waren. We hadden een prachtig Château gevonden in Frans
            Normandi&euml, in het plaatsje Asnières. Een prachtig kasteel met dito bijgebouw.
          </p>
          <p>
            Het Château was van alle gemakken voorzien, met een verkleedkamer, tafeltennistafel, biljarttafel, trampoline en zelfs een tennisbaan! Het weer was prachtig en vooral;
            ontzettend warm. Uiteraard werd er dus weer menig watergevecht uitgevochten. Terwijl de vrouwen Dominion speelden vermaakten de mannen zich met Avalon. Dit geschiedde
            echter dermate luidruchtig, dat het spelen van Avalon sinds die tijd "gevoelig" ligt.
          </p>
          <p>
            Iedere dag werd er ontbijten buiten voor het kasteel. Irving vermaakte de groep met een pubquiz terwijl de plaatselijke huiskat verwoedde pogingen bleef doen om binnen
            te komen. Uitjes waren er o.a. naar Honfleur, Calvados en Lisieux.
          </p>
          <p>
            Memorabel was wel het "verstop dit grote object" slotspel. De deelnemers moesten een groot object in het Château verstoppen, alle andere deelnemers mochten zoeken. De
            groep waarvan het voorwerp als laatste gevonden werd verdiende de meeste punten. Maar hoe hoger je op dat moment stond, hoe groter dat voorwerp was. Zo moest Bokkie een
            stofzuiger verstoppen, maar wist deze toch dermate goed te verstoppen dat hij pas als derde gevonden werd. De biljartkeu die Luuk verstopt had werd uiteindelijk
            helemaal niet gevonden, zelfs Luuk zelf kon hem in eerste instantie niet vinden. Uiteindelijk, na heel veel moeite, kon de keu uit de bank bevrijd worden.
          </p>
          <p>Speciaal voro de Fransen wilden Paul E, Paul K en Dennis nog wel even hun medewerking verlenen en zich als de Franse vlag uitdossen, zie de foto linksonder.</p>
          <p>Met de fiets zat er dit jaar niet in, daar was dit toch echt te ver voor.</p>
          <p>
            <b>Locatie:</b> <a href="https://www.google.nl/maps/place/49.206194,0.404251">Château de Saint Gervais (N 49 12.372, E 0 24.255)</a>
          </p>
        </div>

        <div className="right">
          {toLeadImage("2018_stgervais_1")} {toLeadImage("2018_stgervais_2")} {toLeadImage("2018_stgervais_3")} {toLeadImage("2018_stgervais_4")}
        </div>
      </div>

      <div className="box light">
        <div className="left">
          {title(2019, "Gemmenich (België)")}
          {participants(
            30,
            "Paul K, Onze Marion, Inge, Lieke, Linda, Luuk, Sophie, Ivol, Elise, Mathijs, Evie, Onze Henk, Tineke, Irving, Abel, Lasse, Aldert, Lenny, Jasper, Karlijn, Rianne, Bokkie, Sietze, Thirza, Paul E, Roel, Miek, Han, Meike en Lars"
          )}
          <p>
            We hadden dit keer een huisje genaamd "Iets moois" gevonden net over de grens in Zuid Limburg, in Gemmenich (Belgi&euml;). Het huisje lag vlak bij het drielandenpunt,
            wat op loopafstand lag. Het was een mooi praktisch huis met een zeer ruime tuin met genoeg mogelijkheden tot vermaak. De BBQ was anders dan andere jaren, namelijk een
            grote ronde stenen muur waar 13 zakken houtskool voor nodig waren. Maar uiteraard was ook dit jaar de traditionele BBQ weer van de partij.
          </p>
          <p>
            Menig spelletje werd weer gespeeld, en soms tot diep in de nacht (omdat Terraforming Mars nu eenmaal eindeloos duurt). Onze Henk had dit keer speciaal voor de
            gelegenheid zelfs een presentatie voorbereid. Hij vertelde de ge&iuml;nteresseerden over het verleden van de regio, en dat het drielandenpunt ooit een vierlandenpunt
            was (Moresnet was dat vierde land). Han was er na lange jaren van afwezigheid ook weer eens bij, met vrouw en kind. Hij had weer zijn gitaar meegenomen, net als
            vroeger, om de muzikale begeleiding van de vakantie te verzorgen. Andere nieuwkomer was Thirza, de jongste telg uit de familie van Bochove.
          </p>
          <p>
            De Doortrappers waren dit jaar ook weer van de partij. Voor de tweede keer maakte Inge onderdeel uit van de Doortrappers en volbracht de tocht van Oss helemaal naar
            Gemenich, en weer terug.
          </p>
          <p>
            <b>Locatie:</b> <a href="https://www.google.nl/maps/place/50.753418,5.968653">Iets moois, Gemmenich (N 50 45.205, E 5 58.119)</a>
          </p>
        </div>

        <div className="right">
          {toLeadImage("2019_gemmenich_1")} {toLeadImage("2019_gemmenich_2")} {toLeadImage("2019_gemmenich_3")}
        </div>
      </div>

      <div className="box main">
        <div className="left">
          {title(2020, "Pingjum (Nederland)")}
          {participants(
            31,
            "Paul K, Onze Marion, Inge, Lieke, Linda, Luuk, Sophie, Miek, Ivol, Elise, Mathijs, Evie, Onze Henk, Tineke, Irving, Abel, Lasse, Aldert, Lenny, Jasper, Karlijn, Rianne, Bokkie, Sietze, Thirza, Paul E, Roel (gedeeltelijk), Han, Meike, Elin en Lars"
          )}
          <p>
            Dit huisje in Friesland was enigszins "gedateerd", maar ruim. In de ruime tuin rondom het huis konden de kinderen lekker rondrennen. Het huisje was oud met veel
            kamertjes en spulletjes, wat het een geschikte speurtochthuis maakte. Voor de kinderen werd er een vossenjacht georganiseerd (bovenste foto), waarbij de verkleedzolder
            dienst goed benut kon worden.
          </p>
          <p>
            Uitstapjes waren er o.a. naar de zeehonden op de waddenzee, het friese museumdorp Alingawier, het spoorwegmuseum van Sneek en een Escape Room speciaal voor kinderen
            (middelste foto). Uiteraard werd de traditionale BBQ weer door Paul, Ivo en Elise georganiseerd (onderste foto).
          </p>
          <p>
            Ook de doortrappers waren weer actief, bestaande uit Paul K, Inge, Dennis, Onze Henk, Bokkie en Ivo. De overnachting heen werd doorgebracht in Hotel Saaze, helaas
            zonder Airco terwijl het in de kamer 's avonds laat nog boven de 30 graden was. Op de terugweg werden Gea en Henk Alle nog met een bezoek vereerd in Vollenhove, waarop
            Aldert, Inge en Ivo vervroegd naar huis gingen i.v.m. andere verplichtingen.
          </p>
          <p>
            <b>Locatie:</b> <a href="https://www.google.nl/maps/place/53.1131835,5.4319971">Pingjum (53.1131835,5.4319971)</a>
          </p>
        </div>

        <div className="right">
          {toLeadImage("2020_pingjum_1")} {toLeadImage("2020_pingjum_2")} {toLeadImage("2020_pingjum_3")}
        </div>
      </div>

      <div className="box light">
        <div className="left">
          {title(2021, "Mander (Nederland)")}
          {participants(
            30,
            "Paul K, Onze Marion, Inge, Linda, Luuk, Sophie, Ivol, Elise, Mathijs, Evie, Onze Henk, Tineke, Irving, Abel, Lasse, Aldert, Lenny, Jasper, Karlijn, Rianne, Bokkie, Sietze, Thirza, Naomi, Paul E, Miek, Han, Meike, Lars en Elin"
          )}
          <p>
            Voor deze vakantie hadden we de Manderhoeve gehuurd. De Manderhoeve is slechts 3 jaar geleden gebouwd, dus deze accommodatie was schoon, ruim en mooi opgezet. Bij het
            huisje was er genoeg te doen. Zo speelden de kinderen vaak op de "trampo", werd er zowel gevoetbald (ouders tegen de kinderen) als getafelvoetbald, gevliegerd,
            gebellenblaast, en in de bioscoopzaal op zolder werd een film gekeken.
          </p>
          <p>
            In diezelfde zaal werd ook een kinderquiz en een Lekkveld quiz gehouden. De winnaars van de Lekkveld quiz wonnen daarmee de prachtige klassieker Big Rascal, die ze
            terplekke direct mochten kijken. Omdat de temperatuur echter boven het kookpunt was gestegen besloten ze de film op een later moment te kijken.
          </p>
          <p>
            Uitstapjes waren er naar de lokale graancirkels (om een Harry Potter geocache op te pikken), de Manderveense Aardbei, de molens van Bels en Frans (met lunch, zie foto
            linksonder), het techniekmuseum Oyfo in Hengelo en De Waarbeek eveneens in Hengelo. Plannen waren er om met een groep naar Wildlands te gaan, maar dankzij
            dagjeuit-cadeaukaart.nl kon er niet meer op tijd geboekt worden en gingen uiteindelijk alleen Han en Lars.
          </p>
          <p>
            Uiteraard was er weer de traditionele speurtocht voor kinderen door het bos vlakbij, waar ook gemountainbiked werd. Linda, Lenny, Tineke, Miek en Ivo pikten nog een
            nachtcache op nabij Hardenberg, die zich kenmerkte door een misleidende coordinaat op een electriciteitshuisje.
          </p>
          <p>
            Het was een huisje zonder BBQ, maar gelukkig kon er een 'enorme pan' gehuurd worden bij de slager in het dorpje vlakbij, zodat er toch nog een BBQ kon plaatsvinden.
          </p>
          <p>
            Tijdens de wandeling langs de graancirkels werd net over de grens in Duitsland een vliegend hert gevonden, die Elise op de foto links op haar hand heeft. Het beestje
            was al dood, en werd dus meegenomen in een bakje. Evie heeft er een mooie kamer voor gemaakt met bedje en wat eten.
          </p>
          <p>
            <b>Locatie:</b> <a href="https://www.google.nl/maps/place/52.4451598,6.8211186">Mander (52.4451598,6.8211186)</a>
          </p>
        </div>

        <div className="right">
          {toLeadImage("2021_mander_1")} {toLeadImage("2021_mander_2")} {toLeadImage("2021_mander_3")}
        </div>
      </div>

      <div className="box main">
        <div className="left">
          {title(2022, "Gronau (Duitsland)")}
          {participants(
            34,
            "Paul K, Onze Marion, Inge, Linda, Luuk, Sophie, Ivol, Elise, Mathijs, Evie, Onze Henk, Tineke, Irving, Abel, Lasse, Aldert, Lenny, Jasper, Karlijn, Rianne, Bokkie, Sietze, Thirza, Naomi, Paul E, Miek, Han, Meike, Lars, Elin, Joris, Marigje, Vera en Rutger"
          )}
          <p>
            Dit jaar hadden we de groepsaccommodatie "Dinkler Prinz" afgehuurd, een hele grote accommodatie in het Duitse Gronau. Dat was ook wel nodig, want de groep was dit jaar
            groter dan ooit; 34 personen.
          </p>
          <p>
            Tijdens deze vakantie werd door een aantal Lekkvelders "Wie is de Mol?" gespeeld. Dat leverde soms vreemde taferelen op. Vooral de BBQ was "legendarisch". De ene na de
            andere persoon deed buitengewoon raar. Lenny ging opeens een speech houden, Aldert en Bokkie wilden graag de robotdans doen en Ivo was bijzonder luidruichtig. En dat
            allemaal om deze Wie is de Mol opdracht te winnen. Uiteindelijk bleken Tineke en Irving de Mollen te zijn, maar dat had bijna niemand door.
          </p>
          <p>
            Er werd gezwommen in het openluchtzwembad dichtbij, we bouwden aan de toekomst op vliegveld Twente, we bereidden marshmallows op een kampvuur en we deden een gave
            escape room in Gronau, 1627 genaamd. Voor de kinderen was er een Kahoot quiz, en een allereerste kennismaking met D&D. Op het tetrrein waren diverse speeltoestellen,
            waaronder een trampoline, en natuurlijk; hertjes! De hertjes hadden altijd honger, maar mocht je alleen voeden met appeltjes die uit de appelbomen op het terrein waren
            gevallen.
          </p>
          <p>
            <b>Locatie:</b> <a href="https://www.google.nl/maps/place/52.194015610395404,7.012540476955923">Gronau (52.19400245706432, 7.012540476955923)</a>
          </p>
        </div>

        <div className="right">
          {toLeadImage("2022_gronau_1")} {toLeadImage("2022_gronau_2")} {toLeadImage("2022_gronau_3")}
        </div>
      </div>

      <div className="box light">
        <div className="left">
          {title(2023, "Lo-Reninge (België)")}
          {participants(
            27,
            "Paul K, Onze Marion, Linda, Ivol, Elise, Mathijs, Evie, Onze Henk, Tineke, Irving, Abel, Lasse, Rianne, Bokkie, Sietze, Thirza, Naomi, Paul E, Miek, Han, Meike, Lars, Elin, Joris, Marigje, Vera en Rutger"
          )}
          <p>
            Dit jaar was anders dan anders. We gingen namelijk niet in de zomervakantie, maar al in de meivakantie. We verbleven in vakantiehoeve Walleboom, in het dorpje
            Lo-Reninge. In dat dorpje werd ook de koekjesfabriek van Jules Destrooper bezocht, en de nodige koekjes verorberd en meegenomen.
          </p>
          <p>
            We gingen een dag naar Brugge, te beginnen met een rondvaarttocht door het pitoreske Brugge. Daarna splitste de groep zich in meerdere delen om verschillende dingen in
            Brugge te bezoeken. Wij kozen voor een wandeltocht door Brugge, langs o.a. de grote markt, het Belfort, de Basiliek van het Heilige Bloed en het Begijnenhof.
          </p>
          <p>
            Omdat Duinkerken dichtbij was, gaf Irving weer een van zijn befaamde Battletours. In Duinkerken dus. Ook werd daar het museum over Operation Dynamo uit 1940 bezocht. Na
            afloop was er de keus tussen pizza en friet in een tentje iets van het strand af, want aan het strand zat alles vol.
          </p>
          <p>De Doortrappers kwamen overigens niet in actie, omdat dat qua timing niet mogelijk was en het redelijk ver fietsen was.</p>
          <p>
            <b>Locatie:</b> <a href="https://www.google.nl/maps/place/50.97791270018519,2.7883354866785144">Lo-Reninge (50.97791270018519, 2.7883354866785144)</a>
          </p>
        </div>

        <div className="right">
          {toLeadImage("2023_loreninge_1")} {toLeadImage("2023_loreninge_2")} {toLeadImage("2023_loreninge_3")}
        </div>
      </div>

      <div className="box main">
        <div className="left">
          {title(2024, "Érezée (België)")}
          {participants(
            35,
            "Paul K, Onze Marion, Linda, Luuk, Sophie, Roel, Ivol, Elise, Mathijs, Evie, Onze Henk, Tineke, Irving, Abel, Lasse, Rianne, Bokkie, Sietze, Thirza, Naomi, Paul E, Miek, Han, Meike, Lars, Elin, Joris, Marigje, Vera, Rutger, Lenny, Aldert, Jasper, Karlijn en Lucas"
          )}
          <p>
            Het was even geleden, maar dit jaar hadden we weer een huisje in de Belgische Ardennen uitgezocht. Wederom een voormalig hotel, wat ook nog gewoon op Google terug te
            vinden was. Regelmatig kwamen er dan ook mensen langs die in de veronderstelling waren dat je er terecht kon voor een kopje koffie of een overnachting. Toen er een
            groep van 15 motorrijders aan kwam rijden in de veronderstelling dat ze er koffie konden krijgen, werden ze gastvrij ontvangen werden ze door de kinderen van koffie en
            zelf gebakken popcorn voorzien (foto 2 links).
          </p>
          <p>
            Voor de kinderen werd het spel "De Bedriegers" georganiseerd (zoiets als de Verraders of Wie is de Mol), met iedere dag een opdracht en een test. De eerste dag was een
            opdracht waarbij de kinderen met de tram gingen en er langs het spoor allemaal verklede ouders stonden. Ze moesten onthouden wat die allemaal voor rare kleding
            aanhadden (foto 3).
          </p>
          <p>
            Voor de ouders werd een spel door Han georganiseerd, gebaseerd op het britse TV programma "Taskmaster". 5 kandidaten moesten diverse opdrachten uitvoeren, zoals het
            schrijven van een sonnet en het in een theekopje werpen van een theezakje over een zo lang mogelijke afstand.
          </p>
          <p>De Doortrappers kwamen weer in actie, en namen voor de heenweg zelfs 3 dagen dit keer. En er waren gedurende 1 dag twee extra Doortrappers bij; Irving en Abel.</p>
          <p>We bezochten o.a. de Grotten van Hotton, Durbuy, de chocoladefabriek Cyril in Samrée en de markt van Samrée.</p>

          <p>
            <b>Locatie:</b> <a href="https://www.google.nl/maps/place/50.26748782394848,5.560443929804009">Érezée (50.26748782394848, 5.560443929804009)</a>
          </p>
        </div>

        <div className="right">
          {toLeadImage("2024_erezee_1")} {toLeadImage("2024_erezee_2")} {toLeadImage("2024_erezee_3")}
        </div>
      </div>
    </div>
  );
}

export default Zomervakanties;
